"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AOSComponent({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in",
      delay: 100,
    });
  }, []);

  return <>{children}</>;
}
